import React, {useEffect, useState, useRef} from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { withStyles, recomposeColor } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import EnhancedTable from '../StoreShippingZones/StoreShippingZones'
import Themes from '../Themes/Themes'
import ConfigureForm from '../ConfigureForm/ConfigureForm'
import CircularProgress from '@material-ui/core/CircularProgress'
import PreviewModal from '../PreviewModal/PreviewModal';
import AddSectionName from '../AddSectionName/AddSectionName';
import { renderToString } from 'react-dom/server'
import countries from '../../datasets/countries'
import Templates from '../Templates/Templates'
import NestedShippingZones from '../NestedShippingZones/NestedShippingZones'

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import Backdrop from '@material-ui/core/Backdrop';


import htmlToImage from 'html-to-image';

import Stores from '../AddStores/Stores'

const styles = (theme) => ({
  paper: {
    maxWidth: 936,
    margin: 'auto',
    overflow: 'hidden',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: 'D43636',
  },
  searchBar: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  searchInput: {
    fontSize: theme.typography.fontSize,
  },
  block: {
    display: 'block',
  },
  wht_blk:{
    marginLeft: theme.spacing(2),
  },
  addUser: {
    marginRight: theme.spacing(1),
  },
  contentWrapper: {
    margin: '16px',
  },
  pBar:{
    marginTop: '100px',
    marginBottom: '100px',
    marginLeft: '48%',
    position:'relative',
  },
  backPBar:{
    marginTop: '100px',
    marginBottom: '100px',
    marginLeft: '10%',
    position:'relative',
    color: 'white',
  },
});



const template_options = ['Use once','Create New Template','Modify Template']


function Content(props) {

  const isMountedRef = useRef(null);

  const { classes } = props;

  const [all_shipping_zones, set_shipping_zones] = React.useState([])

  const [nested_shp_zones, set_nested_shp_zones] = React.useState([])

  const [style_sheet, set_style_sheet] = React.useState("")

  const [all_themes, set_themes] = React.useState([])

  const [all_stores, set_stores] = React.useState([])

  const [shipping_error, set_shipping_error] = React.useState(false)

  const [isLoading, setIsLoading] = React.useState(false)

  const [isBackLoading, setIsBackLoading] = React.useState(false)

  const [selected_shipping_zones, setSelectedShippingZones] = React.useState([]);

  const [selected_themes, setSelectedThemes] = React.useState([]);

  const [locations, setLocations] = React.useState(countries);

  const [selected_locations, set_selected_locations] = React.useState([]);

  const [open, setOpen] = React.useState({'open_state':false, 'type':''});

  const [form_title, set_form_title] = React.useState('');

  const [form_body, set_form_body] = React.useState('');

  const [section_name, set_section_name] = React.useState('');

  const [selected_templates, setSelectedTemplates] = React.useState([]);

  const [all_templates, setAllTemplates] = React.useState([]);

  const [ck_state, set_ck_state] = React.useState('')

  const [selected_stores, setSelectedStores] = React.useState([])

  const [template_html, set_template_html] = React.useState({})

  const [selected_template_index, set_selected_template_index] = React.useState(-1)
  
  const [selected_template_option, set_selected_template_option] = React.useState('Use once')

  const [template_description, set_template_description] = React.useState('')

  const [template_name, set_template_name] = React.useState('') 

  const [radioState, setRadioState] = React.useState('Whitelist');

  const [slider_value, set_slider_value] = React.useState(0)

  const reset_state = () =>{
    props.set_header_val(0)
    set_selected_template_index(-1)
    set_selected_template_option('Use once')
    set_template_name('')
    set_template_description('')
    setRadioState('Whitelist')
    set_shipping_zones([])
    set_themes([])
    set_shipping_error(false)
    setIsLoading(false)
    setIsBackLoading(false)
    setSelectedShippingZones([])
    setSelectedThemes([])
    set_ck_state('')
    setOpen({'open_state':false, 'type':''})
    set_form_title('')
    set_form_body('')
    set_section_name('')
    setAllTemplates([])
    set_slider_value(0)
    setSelectedStores([])
    set_style_sheet('')
  }

  const handleRadioChange = (event) => {
    setRadioState(event.target.value);
  };

  const handle_deploy = (type, event) => {

    save_form_to_shopify(section_name, form_title, form_body, selected_themes, selected_locations, ck_state,template_name, radioState,selected_template_option, selected_template_index,template_description,slider_value, selected_stores, type,style_sheet)

  }

  const handle_store_click = (store_domain) => {
    setSelectedStores(store_domain)
  }

  const handleStyleSheetChange = (event) => {
    set_style_sheet(event.target.value)
  }


  const next_clicked = (event) => {
    console.log(' next clicked',props.current_header_val )

    switch (props.current_header_val){

      case 0:

       // if(selected_shipping_zones.length > 0){
          props.set_header_val(1)
          /*
        }else{
          props.handle_snack('error','Please select valid Shipping Zones!',true)
        }*/
        break;

      case 1:
       // if(selected_themes.length === 1){
          props.set_header_val(2)
          /*
        }else{
          props.handle_snack('error','Please select a valid Theme!',true)
        }*/
        break;

      case 2:

        props.set_header_val(3)

        break;

      case 3:

        props.set_header_val(4)

        break;


      case 4:
        
        break;

      default:
        break;

    }

  }


  const refresh_clicked = (event) => {
    /*
    switch (props.current_header_val) {

      case 0:
        if(props.current_shop){
        get_all_shipping_zones(props.current_shop)
        }
        break;
      case 1:
        if(props.current_shop){
        get_all_themes(props.current_shop)
        }
        break;

      case 2:
        get_all_templates(props.current_shop,selected_themes)
        break;
      default:
        break;

    }
    */

   switch (props.current_header_val) {

    case 0:


      if(props.current_shop){

        get_all_stores(props.current_shop)

      }


      break;

    case 1:

      if(props.current_shop){

        get_all_shipping_zones(props.current_shop)

      }

      break;

    case 2:

        if(props.current_shop){

          get_all_themes(props.current_shop)

        }

      break;

    case 3:

        if(props.current_shop){

          get_all_templates(props.current_shop,all_stores)

        }

      break;

    default:

      break;

  }

  };

  const select_template = (index) =>{

    set_selected_template_index(index)
    set_template_name(all_templates[index].template_heading)
    set_template_description(all_templates[index].template_description)
    if(all_templates[index].style_sheet.trim().length > 0){
      set_style_sheet(all_templates[index].style_sheet)
    }
    set_ck_state(all_templates[index].template_body)
    props.set_header_val(4)

  }
  
  const handleClose = () => {
     setOpen({'open_state':false, 'type':''});
  };

  const handleSliderChange = (event, newValue) => {
    set_slider_value(newValue)
  };

  useEffect(() => {

    setSelectedThemes([])
    set_themes([])

  }, [selected_stores])


  useEffect(() => {

    isMountedRef.current = true

    console.log('use effect header called')

    switch (props.current_header_val) {

      case 0:

        if(all_stores.length == 0){
        if(props.current_shop){
        get_all_stores(props.current_shop)
        }
        }
        break;

      case 1:
        if(all_shipping_zones.length == 0){
        if(props.current_shop){
        get_all_shipping_zones(props.current_shop)
        }
        }
        break;

      case 2:
        if(all_themes.length == 0){
          if(props.current_shop){
        get_all_themes(props.current_shop)
          }
        }
        break;

      case 3:
        if(all_templates.length == 0){
          if(props.current_shop){
        get_all_templates(props.current_shop,all_stores)
          }
        }
        break;

      default:
        break;

    }

    return () => isMountedRef.current = false;

  }, [props.current_header_val])
 // placeholder= { props.current_header_val < 2 ? "Search by Name or ID": ""}
 //  {/*disabled = {props.current_header_val < 2 ? false: true}*/}
  return (
    <div>   
    <Paper className={classes.paper}>
     {/*<TextField id="standard-basic" style = {{'width': '90%', margin:'10px'}}label="Name" />*/}
      <AppBar className={classes.searchBar} position="static" color="default" elevation={0}>
        <Toolbar>
          <Grid container spacing={2} alignItems="center">
          {props.current_header_val == 1 ?
            <FormControl className = {classes.wht_blk}  component="fieldset">
         <RadioGroup style={{"marginTop":"2px"}} row aria-label="gender" name="url_type" value={radioState} onChange={handleRadioChange}>
        <FormControlLabel value="Whitelist" control={<Radio color='primary' size="small"/>} label="Whitelist" />
        <FormControlLabel value="Blacklist" control={<Radio color='primary' size="small"/>} label="Blacklist" />
         </RadioGroup>
        </FormControl>
            : null}
           { /*props.current_header_val < 2 ? <Grid item>
              <SearchIcon className={classes.block} color="inherit" />
           </Grid> : null*/}
            <Grid item xs> 
              <TextField
                disabled = {true}
                fullWidth
                placeholder= { ""}
                InputProps={{
                  disableUnderline: true,
                  className: classes.searchInput,
                }}
              />
            </Grid>
            <Grid item>
             
              {props.current_header_val < 4 ?<Button variant="contained" color="primary" className={classes.addUser} onClick={next_clicked}>
               Next
              </Button> : null}
              <Tooltip title="Reload">
                <IconButton onClick = {refresh_clicked.bind(this)}>
                  <RefreshIcon className={classes.block} color="inherit" />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      {isLoading == true ? <CircularProgress className = {classes.pBar} /> : props.current_header_val== 0 ? <div className={classes.contentWrapper}> <Stores selected = {selected_stores} handle_store_click = {handle_store_click} rows = {all_stores}></Stores> </div>: props.current_header_val== 1 ? <div className={classes.contentWrapper}>
        <NestedShippingZones selected = {selected_shipping_zones} setSelected = {setSelectedShippingZones} set_nested_rows ={set_nested_shp_zones}  nested_rows = {nested_shp_zones} rows = {all_shipping_zones} align="center"></NestedShippingZones>
      </div> :  props.current_header_val == 2 ?  <div className={classes.contentWrapper}><Themes handle_snack = {props.handle_snack} selected_stores = {selected_stores} selected = {selected_themes} setSelected = {setSelectedThemes} rows = {all_themes} align="center"></Themes></div> :  props.current_header_val== 3 ? <div className={classes.contentWrapper}><Templates select_template = {select_template} template_html = {template_html} set_template_html = {set_template_html} setOpen = {setOpen} selected = {selected_templates} setSelected = {setSelectedTemplates} rows = {all_templates} align="center"></Templates></div> : props.current_header_val== 4 ? <div className={classes.contentWrapper}><ConfigureForm handle_snack={props.handle_snack} style_sheet = {style_sheet} handleStyleSheetChange = {handleStyleSheetChange} handle_deploy = {handle_deploy}  slider_value = {slider_value} handleSliderChange={handleSliderChange} all_templates = {all_templates} template_description = {template_description} set_template_description = {set_template_description} radioState = {radioState} template_name = {template_name} set_template_name = {set_template_name} selected_template_option = {selected_template_option} set_selected_template_option = {set_selected_template_option} template_options = {template_options} selected_template_index = {selected_template_index} set_selected_template_index={set_selected_template_index} ck_state = {ck_state} set_ck_state = {set_ck_state} sel_shp_zones = {selected_shipping_zones} selectedThemes = {selected_themes} setSelectedThemes = {setSelectedThemes} shp_zones = {all_shipping_zones} all_themes = {all_themes} selected_locations = {selected_locations} set_selected_locations = {set_selected_locations} locations= {locations}  setLocations= {setLocations}  setOpen = {setOpen} form_title = {form_title} form_body = {form_body} section_name = {section_name} set_form_title = {set_form_title} set_form_body = {set_form_body} set_section_name = {set_section_name} align="center"></ConfigureForm></div> : null}
   
    </Paper>

    <PreviewModal style_sheet= {style_sheet} template_html = {template_html} ck_editor_data = {ck_state} open = {open}  handleClose = {handleClose} model_heading={form_title} model_text = {form_body} selected_locations = {locations}></PreviewModal>

    {<Backdrop className={classes.backdrop} open={isBackLoading} >
        <CircularProgress className = {classes.backPBar}/>
          </Backdrop>}

    </div>
    
  );

  



  function renderToStringg() {
   // return renderToString(<PreviewModal open = {open} handleClose = {handleClose} model_heading={form_title}  model_text = {form_body} selected_locations = {locations}/>)
   /*
   var a = document.createElement('div');

    ReactDOM.render(
  <Button>Whatsup</Button> , a );

  console.log(a.outerHTML);
  */
 

  const a = renderToString(<PreviewModal open = {open} handleClose = {handleClose} model_heading={form_title}  model_text = {form_body} selected_locations = {locations}/>)

  console.log(a)


   //return renderToString(<Button>Whatsup</Button>)
  }


  function get_all_shipping_zones(current_shop) {
    console.log('called shipping')

    setIsLoading(true)

  
    fetch('https://gt0425yc42.execute-api.eu-west-2.amazonaws.com/first/shipping-zones'+ current_shop.search,{
        crossDomain:true,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'store_domain': current_shop.shop
        }
      })
        .then(res => res.json())
        .then(
          (result) => {
           
            console.log(result)

            if(isMountedRef.current){
              setIsLoading(false)
            if(result.shipping_zones){                

              const cur_array = []
              result.shipping_zones.forEach((store)=>{
                store.shipping_zones.forEach((shp_zon)=>{
                  cur_array.push({'store_domain':store.store_domain, 'store_email':store.store_email, 'store_id': store.store_id,'store_name': store.store_name,'sh_id':shp_zon.sh_id,'id':shp_zon.id,'name':shp_zon.name,'country':shp_zon.country,'code':shp_zon.code})
                });
              });
              set_shipping_zones(cur_array)
              set_nested_shp_zones(result.shipping_zones)
            }else{
              props.handle_snack('error','Error fetching shipping zones!',true)
              set_shipping_error(true)
            }
          }
            
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            if(isMountedRef.current){
            setIsLoading(false)
            props.handle_snack('error','Error fetching shipping zones!',true)
            console.log(error)
            set_shipping_error(true)
            }
          }
    )
  
  }

  function get_all_themes(current_shop) {

    console.log('called Themes')

    if(selected_stores.length == 0){
        props.handle_snack('error','Please select a valid store!',true)
        return
    }
  
    setIsLoading(true)
  
    fetch('https://gt0425yc42.execute-api.eu-west-2.amazonaws.com/first/themes'+current_shop.search,{
        crossDomain:true,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'store_domain': selected_stores[0]
        }
      })
        .then(res => res.json())
        .then(
          (result) => {
            if(isMountedRef.current){
            setIsLoading(false)

            console.log(result)

            
            if(result && result.themes_data && result.themes_data.themes){     
              const temp_thms = [...result.themes_data.themes]
              temp_thms.map(obj=> obj['color'] = '#FFFFFF')
              set_themes(temp_thms)
            }else{
              props.handle_snack('error','Error fetching themes!',true)
            }
          }
            
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            if(isMountedRef.current){
            setIsLoading(false)
            props.handle_snack('error','Error fetching themes!',true)
            console.log(error)
            }
            //set_shipping_error(true)
          }
    )
  
  
  }
/*
  function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
  
    // Change this to div.childNodes to support multiple top-level nodes
    return div
  }

function image_resolver(html_array) {


    const temp_array = []

    html_array.forEach(element => {

    const dom =  createElementFromHTML(element.template_body)
    console.log('html was', dom)
    htmlToImage.toPng (dom)
    .then(function (dataUrl) {
      console.log('dt url was',dataUrl)
        //var img = new Image();
        //img.src = dataUrl;
         // wait until the promise returns us a value
    
     let result = {"url":dataUrl, "template_heading": element.template_heading, "template_description":element.template_description}

     temp_array.push(result)
        //document.body.appendChild(img);
    })
    .catch(function (error) {
        console.error('oops, something went wrong!', error);
    });

  
    });

    console.log('Temp array was', temp_array)
    setAllTemplates(temp_array)


  }

*/

function createElementFromHTML(htmlString) {
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();

  // Change this to div.childNodes to support multiple top-level nodes
  return div
}

  function get_all_templates(current_shop, all_stores) {


    /*
    if(theme_data.length == 0){
      props.handle_snack('error','Please select a valid theme!',true)
      return
    }
    */

    if(all_stores.length == 0){
      props.handle_snack('error','Please refresh stores!',true)
      return
    }

    console.log(all_stores[0].email)
    setIsLoading(true)
  
    fetch('https://gt0425yc42.execute-api.eu-west-2.amazonaws.com/first/templates' + current_shop.search, {
        crossDomain:true,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'store_domain': current_shop.shop,
          'store_email': all_stores[0].email
        }
      })
        .then(res => res.json())
        .then(
          (result) => {

            if(isMountedRef.current){

            setIsLoading(false)

            console.log("templates were",result.templates)
            
            if(result && result.templates){    


              const temp_array = []

              result.templates.forEach(element => {
          
              //const dom =  createElementFromHTML(element.template_body)
              element.template_body= element.template_body.replace(/↵/g,'')
              let result = {"template_body":element.template_body, "template_heading": element.template_heading, "template_description":element.template_description,"style_sheet":element.style_sheet}
              temp_array.push(result)
             
              });
          
              console.log('Temp array was', temp_array)
              setAllTemplates(temp_array )
            }else{
              props.handle_snack('error','Error fetching templates',true)
            }
          }
            
          },
          (error) => {
            if(isMountedRef.current){
            setIsLoading(false)
            props.handle_snack('error','Error fetching templates!',true)
            console.log(error)
            }

          }
    )
  
  }


  function save_form_to_db(section_name, popup_heading, popup_description,theme_data,shipping_data) {


    if(section_name === "" || popup_heading === "" || popup_description === "" || theme_data.length === 0 || shipping_data.length === 0 ){
      props.handle_snack('error','Please complete section details!',true)
    }else{

      setIsBackLoading(true)


    const store_data = {}

    store_data['section_name'] = section_name
    store_data['popup_heading'] = popup_heading
    store_data['popup_description'] = popup_description
    store_data['theme_data'] = theme_data
    store_data['shipping_data'] = shipping_data
    store_data['store_domain'] = props.current_shop.shop

    
    fetch('https://gt0425yc42.execute-api.eu-west-2.amazonaws.com/first/sections'+ props.current_shop.search,{
      crossDomain:true,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(store_data)
    }).then(res => res.json()).then(
        (result) => {
          if(isMountedRef.current){
          setIsBackLoading(false)
          if(!result.errorMessage){
            props.handle_snack('success','Form successfully created',true)
            reset_state()
          }else{
            props.handle_snack('error','error creating form!',true)
          }
          console.log(result)
        }
          //set_shop_data(result.shop)
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          if(isMountedRef.current){
          setIsBackLoading(false)
          props.handle_snack('error','Error creating form please reload',true)
          console.log(error)
         // set_shop_error(true)
          }
        }
  )

  }
  
  }


  function get_hash_code(s) {
    var hash = 0, i, chr;
    for (i = 0; i < s.length; i++) {
      chr   = s.charCodeAt(i);
      hash  = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }
  



  function save_form_to_shopify(section_name, popup_heading, popup_description,theme_data,shipping_data, editor_data,template_name, radioState,selected_template_option, selected_template_index, template_description,slider_value, selected_stores, type,style_sheet) {


    if((section_name.trim().length === 0 || shipping_data.length === 0 || editor_data.trim().length === 0) || (selected_template_option === 'Create New Template' && template_name.trim().length == 0) || selected_stores.length === 0){
      props.handle_snack('error','Please complete section details!',true)
    }else if(selected_template_index > -1 && selected_template_index < 3 && selected_template_option === 'Modify Template'){
      props.handle_snack('error','You can\'t modify default template, please use once or create a new template',true)
    }else{

    const store_data = {}
    
    var theme_ids = []

    var theme_names = []

    if(theme_data.length == 0 && type == "deploy"){
      props.handle_snack('error','Please select a valid Theme!',true)
      return
    }

    if(style_sheet.trim().length > 0){
      if(!(/^(([a-z0-9\[\]=:]+\s?)|((div|span)?(#|\.){1}[a-z0-9\-_\s?:]+\s?)+)(\{[\s\S][^}]*})$/mi.test(style_sheet.trim())) || style_sheet.includes('<style') || style_sheet.includes('</style>')){
        props.handle_snack('error','Invalid Style Sheet!',true)
        return
      }
      //console.log(/^(([a-z0-9\[\]=:]+\s?)|((div|span)?(#|\.){1}[a-z0-9\-_\s?:]+\s?)+)(\{[\s\S][^}]*})$/mi.test(style_sheet.trim))
    }

  

    setIsBackLoading(true)

    /*

    if(theme_data.length != 0){


      var sel_thm;

      for (sel_thm in theme_data){

      var thm;

      for (thm in all_themes){

        if(all_themes[thm].id == theme_data[sel_thm]){

          theme_ids.push(theme_data[sel_thm])
          theme_names.push(all_themes[thm].name)
          break

        }

      }

      }

    }
    */

    const name_hash = get_hash_code(section_name.trim())

    store_data['section_name'] = section_name.trim()
    store_data['section_hash'] = name_hash
    store_data['popup_heading'] = popup_heading
    store_data['popup_description'] = popup_description
    store_data['themes'] = theme_data
    store_data['shipping_data'] = shipping_data
    store_data['store_domain'] = selected_stores[0]
    store_data['store_info'] = all_stores[0]
    store_data['editor_data'] = editor_data
    store_data['radioState'] = radioState 
    store_data['template_details'] = all_templates[selected_template_index]
    store_data['selected_template_option'] = selected_template_option
    store_data['entered_template_name'] = template_name.trim()
    store_data['entered_template_description'] = template_description
    store_data['remember_for_days'] = slider_value
   // store_data['theme_names'] = theme_names
    store_data['type'] = type
    store_data['style_sheet'] = style_sheet.trim()


    console.log(store_data)


    fetch('https://gt0425yc42.execute-api.eu-west-2.amazonaws.com/first/sections' + props.current_shop.search, {
      crossDomain:true,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(store_data)
    }).then(res => res.json()).then(
        (result) => {
          if(isMountedRef.current){
          setIsBackLoading(false)
          if(result && result.success_message){
            props.handle_snack('success',result.success_message,true)
            reset_state()
          }else{
            var error_message = ''
            if(result && result.message){
              error_message = result.message
            }else{
              error_message = 'Exception with creating form'
            }
            props.handle_snack('error',error_message,true)
          }
          console.log(result)
        }
          //set_shop_data(result.shop)
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          if(isMountedRef.current){
          setIsBackLoading(false)
          props.handle_snack('error','Error creating form',true)
          console.log(error)
          }
         // set_shop_error(true)
        }
  )
  }
  
}

function get_all_stores(current_shop) {
  
  setIsLoading(true)

  fetch('https://gt0425yc42.execute-api.eu-west-2.amazonaws.com/first/connected-stores'+ current_shop.search, {
      crossDomain:true,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'store_domain': current_shop.shop
      }
    }).then(res => res.json())
      .then(
        (result) => {

          console.log('stores were',result)
          if(isMountedRef.current){

            setIsLoading(false)

            if(result.connected_stores){

              set_stores(result.connected_stores)

          }else{

            props.handle_snack('error','Error fetching stores!',true)

          }

          }
  
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          if(isMountedRef.current){
            props.handle_snack('error','Error fetching stores!',true)
          setIsLoading(false)
          }
          console.log(error)
          //set_shipping_error(true)
        }
  )

}

}

Content.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content);


// API Gateway, get all stores with current email

// Get all combined shipping zones

// display shipping zones with store name
